export default __webpack_public_path__ + "static/media/drawerOpen.a6d61c2e.svg";